import React from 'react'
import { CartsAppContext } from '../context/carts-app-context'
import { PriceType } from '../../shared/components'
import {
  isStandalone,
  addOnMinimums,
  hitGeneralAdmissionMax,
  cannotRemove,
  totalTickets
} from '../helpers/logic'
import {
  addOnMaximum,
  baseEventMinimum,
  hitTicketMinimum,
  ticketsWithoutInfants
} from '../../shared/helpers/logic'
import { isEmpty } from 'lodash-es'

const MEMBER_LABELS = ['Members', 'Household']

const shouldStopIncrement = (item, dependencies) => {
  // we want to disable all increment buttons if the quantity limit is hit
  const { quantityLimit, tickets } = item
  const total = totalTickets(ticketsWithoutInfants(tickets))
  if (quantityLimit) return total >= quantityLimit

  // if there are dependencies, we should check the dependent hasn't exceeded its base event
  // isEmpty accounts for all falsey values and an array/object with length == 0
  if (!isEmpty(dependencies)) return addOnMaximum(item, dependencies)

  // otherwise we want the global ticket cap to determine that
  return hitGeneralAdmissionMax(item)
}

function CartTicketType(props) {
  const { item, items, ticket, last, hitMaximumsByAge, dependencies } = props

  const shouldStopDecrement =
    baseEventMinimum(item, items) || hitTicketMinimum(ticket)

  return (
    <CartsAppContext.Consumer>
      {({ actions: { updateCartItem, deleteCartItemTicket } }) => {
        let minimums = isStandalone(item) ? addOnMinimums(items, item) : null

        let checkBaseMinimum = cannotRemove(ticket, item, items, true)
        let baseMinimum =
          typeof checkBaseMinimum === 'boolean'
            ? false
            : checkBaseMinimum.addOnQuantity >=
              checkBaseMinimum.baseEventQuantity

        return (
          <PriceType
            onCart
            item={item}
            ticket={ticket}
            last={last}
            updateItem={updateCartItem}
            deleteCartItemTicket={deleteCartItemTicket}
            remove
            cannotRemove={cannotRemove(ticket, item, items)}
            dualLabel
            useLabel={MEMBER_LABELS.some(label => ticket.label.includes(label))}
            hitMaximumsByAge={hitMaximumsByAge}
            minimums={minimums}
            stopDecrement={shouldStopDecrement || baseMinimum}
            stopIncrement={shouldStopIncrement(item, dependencies)}
          />
        )
      }}
    </CartsAppContext.Consumer>
  )
}

export default CartTicketType
